var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultDataScience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.277 188.986H2.07103C0.929062 188.986 0 188.057 0 186.915V177.915C0 176.773 0.929062 175.844 2.07103 175.844H195.296C196.438 175.844 197.368 176.773 197.368 177.915V186.915C197.348 188.057 196.419 188.986 195.277 188.986Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.095 51.6787C169.052 51.6787 177.935 42.7963 177.935 31.8393C177.935 20.8824 169.052 12 158.095 12C147.138 12 138.256 20.8824 138.256 31.8393C138.256 42.7963 147.138 51.6787 158.095 51.6787Z",
    stroke: "#D3D3D3",
    strokeMiterlimit: 10,
    strokeDasharray: "11.93 11.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.812 41.5365V147.798C188.812 149.075 187.767 150.121 186.49 150.121H23.1298C21.8523 150.121 20.8071 149.075 20.8071 147.798V41.5365C20.8071 40.2591 21.8523 39.2139 23.1298 39.2139H186.49C187.767 39.2139 188.812 40.2591 188.812 41.5365Z",
    stroke: "#E6EEF2",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.741 34.162V140.423C180.741 141.701 179.696 142.746 178.419 142.746H15.0586C13.7812 142.746 12.736 141.701 12.736 140.423V34.162C12.736 32.8845 13.7812 31.8394 15.0586 31.8394H178.419C179.696 31.8394 180.741 32.8845 180.741 34.162Z",
    fill: "#E6EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5367 47.2656C45.7369 47.2656 51.6016 53.1303 51.6016 60.3306C51.6016 67.5308 45.7369 73.3955 38.5367 73.3955C31.3365 73.3955 25.4718 67.5308 25.4718 60.3306C25.4718 53.1303 31.3365 47.2656 38.5367 47.2656ZM38.5367 43.0461C28.9751 43.0461 21.2329 50.7883 21.2329 60.3499C21.2329 69.9115 28.9751 77.6537 38.5367 77.6537C48.0983 77.6537 55.8405 69.9115 55.8405 60.3499C55.8405 50.7883 48.0983 43.0461 38.5367 43.0461Z",
    fill: "#5B5433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5367 43.0461C28.9751 43.0461 21.2329 50.7883 21.2329 60.3499C21.2329 69.9115 28.9751 77.6537 38.5367 77.6537C48.0983 77.6537 55.8405 69.9115 55.8405 60.3499H51.6016C51.6016 67.5501 45.7369 73.4148 38.5367 73.4148C31.3365 73.4148 25.4718 67.5501 25.4718 60.3499C25.4718 53.1497 31.3365 47.285 38.5367 47.285V43.0461Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6351 63.2339C84.0802 68.9824 79.764 74.0342 73.9961 74.4794C68.2475 74.9245 63.1957 70.6083 62.7505 64.8404C62.3054 59.0724 66.6216 54.04 72.3896 53.5948C78.1381 53.1497 83.1899 57.4659 83.6351 63.2339ZM87.0029 62.9629C86.4029 55.3368 79.7446 49.627 72.1186 50.2076C64.4925 50.8077 58.7827 57.4659 59.3633 65.092C59.9634 72.718 66.6216 78.4279 74.2477 77.8472C81.8737 77.2666 87.6029 70.6083 87.0029 62.9629Z",
    fill: "#5B5433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0029 62.9629C86.4029 55.3368 79.7446 49.627 72.1186 50.2076C64.4925 50.8077 58.7827 57.4659 59.3633 65.092C59.9634 72.718 66.6216 78.4279 74.2477 77.8472L73.9767 74.46C68.2281 74.9052 63.1764 70.5889 62.7312 64.821C62.286 59.0531 66.6023 54.0207 72.3702 53.5755C78.1188 53.1303 83.1706 57.4466 83.6157 63.2145L87.0029 62.9629Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.451 56.1304H92.7707V58.7046H171.451V56.1304Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.217 62.2664H92.7707V64.7826H144.217V62.2664Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.451 68.4211H92.7707V70.9374H171.451V68.4211Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.451 74.5571H92.7708V77.0733H171.451V74.5571Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45 87.9312H138.256V135.758H171.45V87.9312Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.249 112.068L126.585 98.7126C129.894 102.429 131.83 107.094 132.12 112.068H113.249Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4741 95.7902C98.5193 92.1901 103.668 90.2158 109.107 90.2158C114.565 90.2158 119.714 92.1901 123.74 95.7708L109.107 110.423L94.4741 95.7902Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.314 116.23C128.733 126.991 119.81 135.546 108.894 135.546C97.5901 135.546 88.435 126.391 88.435 115.088C88.435 109.842 90.4092 105.042 93.661 101.423L93.6803 101.442L108.468 116.23H129.314Z",
    fill: "#FFD049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6791 91.4736H20.6329V94.6479H51.6791V91.4736Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1831 97.0481H20.6331V98.1513H73.1831V97.0481Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1831 100.087H20.6331V101.19H73.1831V100.087Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1831 103.125H20.6331V104.228H73.1831V103.125Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.183 106.165H20.6329V107.268H73.183V106.165Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7887 109.184H20.6331V110.287H47.7887V109.184Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6791 116.016H20.6329V119.191H51.6791V116.016Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.183 121.61H20.6329V122.714H73.183V121.61Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.183 124.649H20.6329V125.752H73.183V124.649Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.183 127.668H20.6329V128.771H73.183V127.668Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.183 130.707H20.6329V131.811H73.183V130.707Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7886 133.746H20.6329V134.849H47.7886V133.746Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4926 77.1312V75.0021C70.4926 75.0021 69.7184 72.873 68.9442 71.3246C69.5249 71.5181 70.4926 72.873 70.4926 72.873C70.4926 72.873 70.8798 69.5826 70.4926 68.8083C73.0089 70.9374 73.0089 71.7117 73.0089 71.7117L72.0411 75.1956L72.2346 77.9054L70.4926 77.1312Z",
    fill: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1043 126.875L32.943 129.004C32.943 129.004 30.6204 130.552 30.6204 131.327C30.6204 132.101 30.6204 133.069 30.6204 133.069L32.3624 135.198C32.3624 135.198 33.9108 130.939 34.1043 131.133C34.2979 132.101 34.2979 133.262 34.685 133.456C34.8786 132.294 34.2979 129.391 35.0721 128.423C35.8463 127.455 34.1043 126.875 34.1043 126.875Z",
    fill: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.471 173.101L33.9979 172.829L33.4072 180.354L36.8803 180.626L37.471 173.101Z",
    fill: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4077 180.373C31.9366 181.805 30.8721 182.889 30.814 183.663C32.0915 184.728 36.2723 185.831 38.2852 184.825C38.6917 182.134 36.8723 180.644 36.8723 180.644L33.4077 180.373Z",
    fill: "#5B5433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9117 172.94H54.4277V180.489H57.9117V172.94Z",
    fill: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6857 118.648C58.0083 125.81 66.9118 155.037 59.3632 176.134C56.1695 178.36 52.6856 176.231 52.6856 176.231C52.6856 176.231 44.8466 145.165 46.9757 132.584C49.1048 120.003 49.3951 118.648 49.3951 118.648H55.6857Z",
    fill: "#5B5433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7179 90.0027H48.9114V96.0029H51.7179V90.0027Z",
    fill: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0855 88.5314C55.0855 91.3767 54.0016 93.6993 51.6983 93.6993C49.395 93.6993 46.7627 91.396 46.7627 88.5314C46.7627 85.6862 48.6208 83.3635 50.9241 83.3635C53.2274 83.3635 55.0855 85.6862 55.0855 88.5314Z",
    fill: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2339 83.4413C53.6145 85.8994 53.15 91.6093 49.7628 93.6029C47.6143 94.6868 41.2851 88.9769 44.3626 83.9058C47.4595 78.8347 53.9242 82.067 54.2339 83.4413Z",
    fill: "#312D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5304 86.8475C48.9998 86.8475 51.0015 84.8457 51.0015 82.3764C51.0015 79.9071 48.9998 77.9053 46.5304 77.9053C44.0611 77.9053 42.0593 79.9071 42.0593 82.3764C42.0593 84.8457 44.0611 86.8475 46.5304 86.8475Z",
    fill: "#312D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9114 96.0027C45.4274 96.3898 40.395 98.906 40.395 98.906C40.395 98.906 34.5883 120.971 33.427 127.746C35.169 128.907 35.7497 129.488 35.7497 129.488L42.3305 107.81L44.8467 118.649H55.6858L58.202 104.713C58.202 104.713 74.4606 96.7769 73.1057 77.2279C70.0088 75.873 70.0088 75.873 70.0088 75.873C70.0088 75.873 70.783 96.5834 55.6858 96.1963C55.6858 96.1963 50.8469 95.2285 48.9114 96.0027Z",
    fill: "#FFD049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.866 118.648C38.0915 130.455 29.5751 160.456 32.672 176.908C35.8657 179.521 38.4787 176.908 38.4787 176.908C38.4787 176.908 50.0919 151.553 49.8984 133.359C50.6726 122.52 49.8984 118.648 49.8984 118.648H44.866Z",
    fill: "#5B5433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4277 180.49C53.0728 182.038 52.105 183.199 52.105 183.973C53.4599 184.941 57.7181 185.715 59.6536 184.554C59.8472 181.844 57.9117 180.49 57.9117 180.49H54.4277Z",
    fill: "#5B5433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.993 163.689C182.406 156.237 177.471 149.579 170.832 145.863C174.393 152.579 178.632 158.908 183.509 164.754L183.993 163.689Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.774 166.496C179.445 157.65 176.27 146.579 176.948 135.72C181.051 145.747 184.148 156.179 186.18 166.805L185.774 166.496Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.974 166.805C183.78 161.366 183.587 155.869 184.439 150.489C185.29 145.108 187.264 139.785 190.923 135.74C191.484 146.888 188.774 158.173 183.258 167.87L183.974 166.805Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.226 167.289C180.664 156.992 181.245 145.34 185.813 135.449C188.677 145.785 186.142 156.74 183.606 167.154L184.226 167.289Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.71 163.476C185.697 154.437 191.716 146.134 200 142.398C196.652 151.398 190.903 159.508 183.529 165.683L184.71 163.476Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.226 161.889L192.2 179.425C192.2 180.277 191.503 180.954 190.671 180.954H178.516C177.664 180.954 176.987 180.258 176.987 179.425L176.755 175.457L175.961 161.889C175.961 161.038 176.658 160.36 177.49 160.36H191.697C192.258 160.36 192.742 160.65 193.013 161.096C193.149 161.328 193.226 161.599 193.226 161.889Z",
    fill: "#E6EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.226 161.889L192.2 179.425C192.2 180.277 191.503 180.954 190.671 180.954H178.516C177.664 180.954 176.987 180.257 176.987 179.425L176.755 175.457C182.426 173.831 188.271 166.825 193.013 161.095C193.149 161.328 193.226 161.599 193.226 161.889Z",
    fill: "#E6EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0072 169.651C11.962 164.773 8.74902 160.418 4.39404 157.979C6.7167 162.373 9.50388 166.515 12.6975 170.347L13.0072 169.651Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1684 171.489C10.0263 165.702 7.93592 158.463 8.3811 151.34C11.0715 157.902 13.1038 164.734 14.42 171.702L14.1684 171.489Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9878 171.683C12.8524 168.121 12.7362 164.521 13.2975 160.998C13.8588 157.476 15.1557 153.992 17.5557 151.34C17.9235 158.637 16.1621 166.031 12.5233 172.379L12.9878 171.683Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1425 172.012C10.8005 165.276 11.1876 157.631 14.1877 151.166C16.0652 157.921 14.4006 165.102 12.7361 171.915L13.1425 172.012Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4526 169.515C14.0913 163.612 18.0398 158.153 23.4593 155.715C21.2528 161.618 17.4979 166.921 12.6783 170.967L13.4526 169.515Z",
    fill: "#79CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0462 168.47L18.3688 179.948C18.3688 180.509 17.9236 180.954 17.3623 180.954H9.40719C8.84588 180.954 8.40071 180.509 8.40071 179.948L8.24586 177.354L7.72327 168.47C7.72327 167.909 8.16844 167.463 8.72975 167.463H18.0397C18.4075 167.463 18.7172 167.657 18.8914 167.947C18.9881 168.102 19.0462 168.276 19.0462 168.47Z",
    fill: "#E6EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0462 168.47L18.3687 179.948C18.3687 180.509 17.9236 180.954 17.3623 180.954H9.40718C8.84587 180.954 8.40069 180.509 8.40069 179.948L8.24585 177.354C11.9621 176.289 15.7945 171.702 18.8913 167.947C18.9881 168.102 19.0462 168.276 19.0462 168.47Z",
    fill: "#E6EEF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultDataScience);
export default __webpack_public_path__ + "static/media/result_data-science.2f55048ef7933780ad5bd21cebd39a96.svg";
export { ForwardRef as ReactComponent };